// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-builder {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

/* Question reordering animation */
@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0.8;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0.8;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.question-card-moving-up {
  animation: slideUp 0.3s ease-in-out;
}

.question-card-moving-down {
  animation: slideDown 0.3s ease-in-out;
}

.builder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #eee;
}

.builder-header h1 {
  color: #333;
  font-size: 1.8rem;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.survey-info {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.title-input {
  width: 100%;
  padding: 0.75rem;
  font-size: 1.2rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.description-input {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  min-height: 80px;
}

.questions-section {
  margin-bottom: 2rem;
}

.question-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.question-number {
  font-weight: bold;
  color: #666;
}

.btn-icon {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
}

.btn-icon:hover {
  background: #c82333;
}

.question-input {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.question-options {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.question-type-select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.required-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.options-list {
  padding-left: 1rem;
}

.option-item {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  align-items: center;
}

.option-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn-icon-sm {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
}

.rating-config {
  display: flex;
  gap: 1rem;
  padding-left: 1rem;
}

.rating-config label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.rating-input {
  width: 60px;
  padding: 0.25rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.add-question {
  width: 100%;
  padding: 1rem;
  border: 2px dashed #ddd;
  background: #f8f9fa;
}

.add-question:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.publish-section {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.publish-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyBuilder.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".survey-builder {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n/* Question reordering animation */\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0.8;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-20px);\n    opacity: 0.8;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.question-card-moving-up {\n  animation: slideUp 0.3s ease-in-out;\n}\n\n.question-card-moving-down {\n  animation: slideDown 0.3s ease-in-out;\n}\n\n.builder-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #eee;\n}\n\n.builder-header h1 {\n  color: #333;\n  font-size: 1.8rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.survey-info {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.title-input {\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1.2rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.description-input {\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.questions-section {\n  margin-bottom: 2rem;\n}\n\n.question-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.question-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.question-number {\n  font-weight: bold;\n  color: #666;\n}\n\n.btn-icon {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-icon:hover {\n  background: #c82333;\n}\n\n.question-input {\n  width: 100%;\n  padding: 0.5rem;\n  font-size: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.question-options {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  align-items: center;\n}\n\n.question-type-select {\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.required-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.options-list {\n  padding-left: 1rem;\n}\n\n.option-item {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  align-items: center;\n}\n\n.option-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.btn-icon-sm {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.rating-config {\n  display: flex;\n  gap: 1rem;\n  padding-left: 1rem;\n}\n\n.rating-config label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rating-input {\n  width: 60px;\n  padding: 0.25rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.add-question {\n  width: 100%;\n  padding: 1rem;\n  border: 2px dashed #ddd;\n  background: #f8f9fa;\n}\n\n.add-question:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.publish-section {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.publish-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
